import React, { useEffect, useState } from "react";
import { getImageUrl } from "utils/imageGallery/index";
import HeaderImage from "assets/images/nzCaseStudy/header.png";
import FooterImage from "assets/images/nzCaseStudy/footerNZ.png";
import "../styles.css";

const NZReportPDFPageDetails = ({ imageData = {}, index }) => {
    const [imageWithFixedUrl, setImageWithFixedUrl] = useState([]);
    const [imgIsWide, setImgIsWide] = useState(false);

    useEffect(() => {
        const fetchImage = async () => {
            const fileUrl = await getImageUrl(imageData.fileUrl);
            setImageWithFixedUrl({ ...imageData, fileUrl });
        };

        fetchImage();
    }, [imageData]);

    useEffect(() => {
        const img = new Image();
        img.src = imageWithFixedUrl.fileUrl;
        img.onload = function () {
            // Access naturalWidth and naturalHeight for original dimensions
            const naturalWidth = this.naturalWidth;
            const naturalHeight = this.naturalHeight;

            setImgIsWide((prev) => ({
                ...prev,
                [imageWithFixedUrl.id]: naturalHeight < naturalWidth,
            }));
        };
    }, [imageWithFixedUrl]);

    return (
        <div className="bodyNZPDF">
            <img src={HeaderImage} alt="header" />
            <span className="headerTextNZPDF">TECHNICAL DETAIL {index + 1}</span>
            <div
                className="pageContainerNZPDF"
                style={{
                    flex: 1,
                    background: "#fff",
                    margin: "0 10px",
                    padding: "10px 0",
                    maxWidth: "795px",
                }}
            >
                <div className="imageFullNZPDF">
                    <div key={imageWithFixedUrl.id} className="imageFullContainerNZPDF">
                        <div className="fullImageNZPDF">
                            <img
                                src={`${imageWithFixedUrl.fileUrl}`}
                                className={imgIsWide[imageWithFixedUrl.id] ? "wideImage" : "tallImage"}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="detailsContainerNZPDF">
                <span>{imageWithFixedUrl.notes?.slice(0, 100)}</span>
            </div>
            <img src={FooterImage} alt="footer" />
        </div>
    );
};

export default NZReportPDFPageDetails;
